import styled from "styled-components"
import { Typography } from "../../../typography"

export const Textarea = styled(Typography).attrs<{
  as?: React.ElementType
}>((props) => {
  return {
    $variant: "body-4-medium",
    as: props.as ?? "textarea",
  }
})<{
  $isInError?: boolean
  as?: React.ElementType
  $fullWidth?: boolean
}>`
  color: ${({ theme }) => theme.colors.grey.$600};

  border: 1px solid ${({ theme, $isInError }) => ($isInError ? theme.colors.danger.$200 : theme.colors.grey.$200)};
  outline: 0 solid ${({ theme }) => theme.colors.grey.$400};
  box-shadow: ${({ theme }) => theme.shadows.light};
  border-radius: 0.5rem;

  height: 6.5rem;
  width: ${({ $fullWidth }) => ($fullWidth ? "100%" : "21.875rem")};
  padding: 0 0.5rem;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;

  transition:
    outline 0.2s ease,
    color 0.2s ease;
  box-sizing: border-box;

  &::placeholder {
    color: ${({ theme }) => theme.colors.grey.$400};
  }

  &:active {
    border: 1px solid ${({ theme }) => theme.colors.grey.$600};
  }

  &:focus {
    outline: 2px solid ${({ theme }) => theme.colors.grey.$400};
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
  }

  &:disabled {
    border: 1px solid ${({ theme }) => theme.colors.grey.$200};
    background-color: ${({ theme }) => theme.colors.grey.$200};
  }
`
